import React from 'react';
const MOCKUP_URL = 'https://cdn.magicpatterns.com/uploads/otxMUQBHVeV2uxxSxmC7Ss/Mockuo_modelo_Diesel_fault_atlas.png';
export function ProductMockup({
  className = '',
  eager = false
}: {
  className?: string;
  eager?: boolean;
}) {
  return <img src={MOCKUP_URL} alt="Diesel Fault Atlas: six volumes in a slipcase — Workflow, Fuel Systems, Air & Boost, Electrical, Emissions, and Case Studies — beside the cover reading 'Trace the symptom. Test the cause.'" className={`block h-auto w-full select-none object-contain ${className}`} loading={eager ? 'eager' : 'lazy'} draggable={false} data-id="element-26" data-mp="2okxwcluyl802" />;
}